import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";

const EmailAttachment = () => {
  const { adminMode, barangayId } = useParams();
  const [emails, setEmails] = useState([]);
  const [newEmail, setNewEmail] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const encoderUrl = `${process.env.REACT_APP_API_URL}/api/encoders?barangay_code=${barangayId}`;
  const barangayUrl = `${process.env.REACT_APP_API_URL}/api/barangay-admins?barangay_code=${barangayId}`;
  const municipalUrl = `${process.env.REACT_APP_API_URL}/api/municipal-admins?municipal_code=${barangayId}`;
  const provincialUrl = `${process.env.REACT_APP_API_URL}/api/provincial-admins?provincial_code=${barangayId}`;

  const fetchEmails = async () => {
    try {
      let url
      if(adminMode === 'province'){
        url = provincialUrl;
      }
      else if(adminMode === 'municipality'){
        url = municipalUrl;
      }
      else if(adminMode === 'barangay'){
        url = barangayUrl;
      }
      else{
        url = encoderUrl;
      }
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_API_KEY,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to fetch emails.");
      }

      const data = await response.json();
      setEmails(data.map((admin) => admin.email)); // Assuming the response contains an array of barangay admins
    } catch (error) {
      alert(`Error: ${error.message}`);
    }
  };

  const addEncoderToBarangay = async (email) => {
    try {
      const userId = localStorage.getItem("userId");
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/encoders`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_API_KEY,
        },
        body: JSON.stringify({
          barangay_code: barangayId,
          email,
          created_by: userId,
          status: "active",
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to add email.");
      }

      const data = await response.json();
      alert(data.message || "Email added successfully.");
    } catch (error) {
      alert(`Error: ${error.message}`);
    }
  };

  const addEmailToBarangay = async (email) => {
    try {
      const userId = localStorage.getItem("userId");
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/barangay-admins`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_API_KEY,
        },
        body: JSON.stringify({
          barangay_code: barangayId,
          email,
          created_by: userId,
          status: "active",
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to add email.");
      }

      const data = await response.json();
      alert(data.message || "Email added successfully.");
    } catch (error) {
      alert(`Error: ${error.message}`);
    }
  };
  const addEmailToMunicipality = async (email) => {
    try {
      const userId = localStorage.getItem("userId");
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/municipal-admins`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_API_KEY,
        },
        body: JSON.stringify({
          municipal_code: barangayId,
          email,
          created_by: userId,
          status: "active",
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to add email.");
      }

      const data = await response.json();
      alert(data.message || "Email added successfully.");
    } catch (error) {
      alert(`Error: ${error.message}`);
    }
  };
  const addEmailToProvince = async (email) => {
    try {
      const userId = localStorage.getItem("userId");
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/provincial-admins`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_API_KEY,
        },
        body: JSON.stringify({
          provincial_code: barangayId,
          email,
          created_by: userId,
          status: "active",
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to add email.");
      }

      const data = await response.json();
      alert(data.message || "Email added successfully.");
    } catch (error) {
      alert(`Error: ${error.message}`);
    }
  };

  // Function to delete email from the backend
  const deleteEmailFromEncoders = async (emailToDelete) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/encoders`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_API_KEY,
        },
        body: JSON.stringify({
          barangay_code: barangayId,
          email: emailToDelete,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to remove email.");
      }

      const data = await response.json();
      alert(data.message || "Email removed successfully.");
      return true; // Indicate success
    } catch (error) {
      alert(`Error: ${error.message}`);
      return false; // Indicate failure
    }
  };
  // Function to delete email from the backend
  const deleteEmailFromBarangay = async (emailToDelete) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/barangay-admins`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_API_KEY,
        },
        body: JSON.stringify({
          barangay_code: barangayId,
          email: emailToDelete,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to remove email.");
      }

      const data = await response.json();
      alert(data.message || "Email removed successfully.");
      return true; // Indicate success
    } catch (error) {
      alert(`Error: ${error.message}`);
      return false; // Indicate failure
    }
  };
  const deleteEmailFromMunicipality = async (emailToDelete) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/municipal-admins`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_API_KEY,
        },
        body: JSON.stringify({
          municipal_code: barangayId,
          email: emailToDelete,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to remove email.");
      }

      const data = await response.json();
      alert(data.message || "Email removed successfully.");
      return true; // Indicate success
    } catch (error) {
      alert(`Error: ${error.message}`);
      return false; // Indicate failure
    }
  };
  const deleteEmailFromProvince = async (emailToDelete) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/provincial-admins`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_API_KEY,
        },
        body: JSON.stringify({
          provincial_code: barangayId,
          email: emailToDelete,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to remove email.");
      }

      const data = await response.json();
      alert(data.message || "Email removed successfully.");
      return true; // Indicate success
    } catch (error) {
      alert(`Error: ${error.message}`);
      return false; // Indicate failure
    }
  };

  const handleAddEmail = async () => {
    if (!isValidEmail(newEmail)) {
      alert("Please enter a valid email address.");
      return;
    }
    if (emails.includes(newEmail)) {
      alert("This email is already attached.");
      return;
    }
    if( adminMode === 'province' ) await addEmailToProvince(newEmail);
    else if( adminMode === 'municipality' ) await addEmailToMunicipality(newEmail);
    else if( adminMode === 'barangay' ) await addEmailToBarangay(newEmail);
    else addEncoderToBarangay(newEmail);
    setEmails([...emails, newEmail]);
    setNewEmail("");
  };

  const handleRemoveEmail = async (emailToRemove) => {
    if (adminMode === 'province') {
      const success = await deleteEmailFromProvince(emailToRemove);
    } else if (adminMode === 'municipality') {
      const success = await deleteEmailFromMunicipality(emailToRemove);
    } else if (adminMode === 'barangay'){
      const success = await deleteEmailFromBarangay(emailToRemove);
    } else {
      const success = await deleteEmailFromEncoders(emailToRemove);
    }
  };

  useEffect(() => {
    fetchEmails();
  }, [barangayId]);

  return (
    <div style={{ maxWidth: "600px", margin: "0 auto", padding: "1rem" }}>
      <h1>Email Attachment</h1>
      <p>Manage emails for {adminMode} ID: {barangayId}</p>
      <ui5-input
        placeholder="Enter email"
        value={newEmail}
        onInput={(e) => setNewEmail(e.target.value)}
        style={{ width: "100%", marginBottom: "1rem" }}
      ></ui5-input>
      <ui5-button design="Emphasized" onClick={handleAddEmail}>
        Add Email
      </ui5-button>
      <ui5-button
        design="Transparent"
        onClick={() => {
          // Pass filters back to UserMaintenance
          navigate("/user-maintenance", { state: { filters: location.state?.filters || {} } });
        }}
        style={{ marginLeft: "1rem" }}
      >
        Back
      </ui5-button>
      <ul style={{ marginTop: "1rem" }}>
        {emails.map((email) => (
          <li key={email} style={{ display: "flex", justifyContent: "space-between" }}>
            <span>{email}</span>
            <ui5-button design="Negative" onClick={() => handleRemoveEmail(email)}>
              Remove
            </ui5-button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default EmailAttachment;
